export default [
  {
    path: '/customers',
    name: 'customers',
    component: () =>
      import(/* webpackChunkName: "customers" */
        /* webpackMode: "lazy" */
        `./views/CustomerList.vue`)
  },
  {
    path: '/customers/__',
    name: 'new-customer',
    component: () =>
      import(/* webpackChunkName: "customers" */
        /* webpackMode: "lazy" */
        `./views/CustomerNew.vue`)
  },
  {
    path: '/customers/:id',
    name: 'single_customer',
    component: () =>
      import(/* webpackChunkName: "customers" */
        /* webpackMode: "lazy" */
        `./views/CustomerSingle.vue`)
  },
  {
    path: '/groups',
    name: 'groups',
    component: () =>
      import(/* webpackChunkName: "customer_groups" */
        /* webpackMode: "lazy" */
        `./views/CustomerGroupList`)
  },
  {
    path: '/groups/__',
    name: 'new-customer-group',
    component: () =>
      import(/* webpackChunkName: "customer_groups" */
        /* webpackMode: "lazy" */
        `./views/CustomerGroupNew`)
  },
  {
    path: '/groups/:id',
    name: 'single-customer-group',
    component: () =>
      import(/* webpackChunkName: "customer_groups" */
        /* webpackMode: "lazy" */
        `./views/CustomerGroupSingle.vue`)
  }
]
